import React from "react";
import { useForm } from "react-hook-form";
import Header from "./Header";
import { Rocket, Contact } from "../assets";

export default function ContactForm() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => console.log(data);
  console.log(errors);

  return (
    <section className="flex flex-col items-center justify-center mt-[2rem] min-h-screen">
      <Header
        title="Contact Us"
        subtitle="Connect with us for inquiries, collaborations, and assistance."
      />
      <div className="flex justify-between gap-[50px] lg:gap-[130px] xl:gap-0 flex-col lg:flex-row">
        <div className="">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="p-4 text-base leading-relaxed max-w-[600px] border border-hl rounded-md"
          >
            Hello! My name is{" "}
            <input
              type="text"
              placeholder="your name"
              {...register("name", { required: true, maxLength: 80 })}
              className="outline-none border-0 p-0 mx-2 focus:ring-0 placeholder:text-center placeholder:text-base placeholder:text-hl placeholder:tex-medium border-b border-black
        focus:border-gray bg-transparent"
            />
            and I want to discuss a potential project. You can email me at
            <input
              type="email"
              placeholder="your@email"
              {...register("email", {})}
              className="outline-none border-0 p-0 mx-2 focus:ring-0 placeholder:text-center placeholder:text-base placeholder:text-hl placeholder:tex-medium border-b border-black
        focus:border-gray bg-transparent"
            />
            or reach out to me on
            <input
              type="tel"
              placeholder="your phone"
              {...register("phone number", {})}
              className="outline-none border-0 p-0 mx-2 focus:ring-0 placeholder:text-center placeholder:text-base placeholder:text-hl placeholder:tex-medium border-b border-black
        focus:border-gray bg-transparent"
            />
            Here are some details about my project: <br />
            <textarea
              {...register("project details", {})}
              placeholder="My project is about..."
              rows={3}
              className="w-full outline-none border-0 p-0 mx-0 focus:ring-0  placeholder:text-base placeholder:text-hl placeholder:tex-medium border-b border-black
        focus:border-gray bg-transparent"
            />
            <input
              type="submit"
              value="send"
              className="px-4 py-2 btn-primary mt-8 inline-block capitalize hover:text-white cursor-pointer"
            />
          </form>
        </div>
        <div className="relative banner-wrapper feature-banner bg-green-950">
          <figure className="features-banner one">
            <img
              src={Rocket}
              loading="lazy"
              alt="features"
              className="max-w-[400px] object-cover"
            />
          </figure>
          <figure className="absolute features-banner two -bottom-[150px] right-0">
            <img
              src={Contact}
              loading="lazy"
              alt="features"
              className="w-[260px] md:w-full md:min-w-[300px] max-w-[460px] rounded-lg object-cover"
            />
          </figure>
        </div>
      </div>
    </section>
  );
}
